<template>
  <div
    v-if="true"
    class="card card-small">
    <div
      v-if="!loaded"
      class="overlay-loading">
      <h2 class="preloader isLoading">Trwa ładowanie</h2>
    </div>
    <div class="card-body p-0 pb-3 text-center">
      <table class="table mb-0 responsive-table">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">Data wpłaty</th>
            <th scope="col" class="border-0">Kwota płatności</th>
            <th scope="col" class="border-0">Umowa w trakcie płatności</th>
            <th scope="col" class="border-0" style="">Akcje</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="payment in payment_history"
            :key="payment.id">
            <td>
              <dt>Data wpłaty</dt>
              <dd>
                {{ payment.paid_date }}
              </dd>
            </td>
            <td>
              <dt>Kwota płatności</dt>
              <dd>
                {{ toNumber(payment.amount) }} zł
              </dd>
            </td>
            <td>
              <dt>Umowa w trakcie płatności</dt>
              <dd>
                {{ lang[payment.payment_type] }}
              </dd>
            </td>
            <td>
              <dt>Akcje</dt>
              <dd v-if="!finished">
                <d-button
                  theme="danger"
                  @click.prevent="removePayment(payment.id)">
                  Usuń
                </d-button>
              </dd>
              <dd v-else>-</dd>
            </td>
          </tr>
          <tr v-if="!payment_history.length">
            <td
              colspan="4"
              class="text-center text-info">
              Brak płatności do wyświetlenia.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer">
      <ss-pagination
        :meta-data="paginationMetaData"
        :initial-page="currentPage" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import ListUtils from '@/utils/ListUtils';
import SsPagination from '@/components/common/SsPaginationNew';
import HasPagination from '@/mixins/HasPagination';

export default {
  name: 'PaymentsHistory',
  mixins: [HasPagination],
  components: {
    SsPagination,
  },
  props: {
    finished: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lang: {
        contract_during: 'W trakcie trwania',
        contract_in_execution: 'W egzekucji',
        contract_terminated: 'Wypowiedziana',
        during_execution: 'W trakcie egzekucji',
        entire_installment: 'Cała rata',
        partial_payment: 'Częściowa',
      },
      actionInProgress: false,
      loaded: false,
      loadError: false,
      payment_history: [],
    };
  },
  mounted() {
    this.$eventHub.$on('refresh-payments-history', this.loadItemsData);
    this.loadItemsData();
  },
  methods: {
    loadItemsData() {
      ListUtils.loadItemsData(this, {
        method: 'post',
        endpoint: '/api/get-payment-history',
        listField: 'payment_history',
        pagination: true,
        params: {
          client_id: this.$route.params.client_id,
          schedule_id: this.$route.params.schedule_id,
          page: this.currentPage,
        },
      });
    },
    debouncedLoadFilteredData: _.debounce(function () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.loadItemsData();
    }, 500),
    removePayment(paymentId) {
      this.actionInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/api/delete-payment-history',
        id: paymentId,
        successTitle: 'Płatność została usunięta',
        successText: '',
        confirmTitle: 'Uwaga',
        confirmText: 'Czy potwierdzasz usunięcie płatności?',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie płatności nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.actionInProgress = false;
          this.$bus.$emit('reload-contract');
          this.debouncedLoadFilteredData();
        },
        failAction: () => {
          this.actionInProgress = false;
        },
        cancelAction: () => {
          this.actionInProgress = false;
        },
      });
    },
    toNumber(number) {
      return Vue.toNumber(number);
    },
  },
  beforeDestroy() {
    this.$eventHub.$off('refresh-payments-history', this.loadItemsData);
  },
};
</script>

